<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="app" :class="vueAppClasses">
    <router-view @setAppClasses="setAppClasses" @accept="() => {}" />
  </div>
</template>

<script>
import themeConfig from "@/../themeConfig.js";

import { apiFactory } from "./api/apiFactory";
const baseDataApi = apiFactory.get("baseDataApi");
const accountApi = apiFactory.get("accountApi");
const publisherAccountApi = apiFactory.get("publisherAccountApi");

export default {
  data() {
    return {
      vueAppClasses: [],
    };
  },
  watch: {
    "$store.state.theme"(val) {
      this.toggleClassInBody(val);
    },
    "$vs.rtl"(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr");
    },
  },
  methods: {
    toggleClassInBody(className) {
      if (className == "dark") {
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
        document.body.classList.add("theme-dark");
      } else if (className == "semi-dark") {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        document.body.classList.add("theme-semi-dark");
      } else {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
      }
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr);
    },
    handleWindowResize() {
      this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

      // Set --vh property
      document.documentElement.style.setProperty(
        "--vh",
        `${window.innerHeight * 0.01}px`
      );
    },
    handleScroll() {
      this.$store.commit("UPDATE_WINDOW_SCROLL_Y", window.scrollY);
    },
    appMounted() {
      if (!this.$store.state.languages) {
        baseDataApi
          .getLanguages()
          .then((response) => {
            this.$store.commit("updateLanguageList", response.data);
          })
          .catch(() => {});
      }
      if (!this.$store.state.currencies) {
        baseDataApi
          .getCurrencies()
          .then((response) => {
            this.$store.commit("updateCurrencyList", response.data);
          })
          .catch(() => {});
      }
      if (!this.$store.state.contactMethods) {
        baseDataApi
          .getContactMethods()
          .then((response) => {
            this.$store.commit("updateContactMethodList", response.data);
          })
          .catch(() => {});
      }
      let api =
        this.$store.state.AppActiveUser.user.type === 1
          ? publisherAccountApi
          : accountApi;
      api
        .settings()
        .then((res) => {
          this.$store.commit("setSiteConfig", res.data);
          document.title = res.data.title + " | " + res.data.slogan;
          document.description = res.data.description;
          let favicon = document.createElement("link");
          favicon.setAttribute("rel", "icon");
          favicon.setAttribute(
            "href",
            res.data.favicon.replace(/^http:\/\//i, "https://")
          );
          var head = document.querySelector("head");
          head.appendChild(favicon);
        })
        .then(() => {

          if (this.$store.state.AppActiveUser) {
            if (this.$store.state.AppActiveUser.user.type !== 1) {
              accountApi
                .getProfile()
                .then((response) => {
                  // console.log('---resp data----');
                  // console.log(response.data);
                  // console.log('----');
                  if (
                    this.$store.state.AppActiveUser.user.type === 2 ||
                    this.$store.state.AppActiveUser.user.type === 3
                  ) {
                    let data = JSON.parse(localStorage.getItem("userInfo"));
                    data.data.user.role = response.data.role;
                    data.data.user.is_client = response.data.is_client;
                    data.data.user.profile = response.data.profile;
                    data.data.user.has_role = response.data.has_role;
                    this.$store.commit("UPDATE_USER_INFO", data);
                    localStorage.setItem("userInfo", JSON.stringify(data));
                  }
                  this.$store.commit("updatePreferred", {
                    preferred_currency:
                      response.data.profile.preferred_currency_data,
                    preferred_language:
                      response.data.profile.preferred_language_data,
                  });
                })
                .catch(() => {});
            }
          }
        })
        .catch(() => {});
    },
  },
  computed: {
    languages() {
      return this.$store.state.languages;
    },
  },
  mounted() {
    this.toggleClassInBody(themeConfig.theme);
    this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
    // console.log('----user info--------');
    // console.log(localStorage.getItem("userInfo"));
    // console.log('-------');
    if (localStorage.getItem("userInfo")) {
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.$store.commit("UPDATE_USER_INFO", userInfo);
      let language = "se";
      let currency = "SEK";
      if (localStorage.getItem("language")) {
        language = JSON.parse(localStorage.getItem("language")).codename;
      }
      if (localStorage.getItem("currency")) {
        currency = JSON.parse(localStorage.getItem("currency")).codename;
      }

      this.$store.commit("updateAxiosConfig", {
        accessToken: userInfo.data.token.key,
        language: language,
        currency: currency,
      });
      this.appMounted();
    }
  },
  created() {
    let dir = this.$vs.rtl ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);

    window.addEventListener("resize", this.handleWindowResize);
    window.addEventListener("scroll", this.handleScroll);
  },
  unmounted() {
    window.removeEventListener("resize", this.handleWindowResize);
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style>
.vdp-datepicker.invalid input {
  border-color: rgba(var(--vs-danger), 1);
}

.vdp-datepicker.valid input {
  border-color: rgba(var(--vs-success), 1);
}

.v-select.invalid .vs__dropdown-toggle {
  border-color: rgba(var(--vs-danger), 1);
}

.v-select.valid .vs__dropdown-toggle {
  border-color: rgba(var(--vs-success), 1);
}

.vx-input-group .vs-inputx {
  border-left: 0 !important;
  padding-left: 3px !important;
}

.vx-input-group .vs-inputx:focus {
  box-shadow: none;
}

.vdp-datepicker__clear-button {
  position: absolute;
  right: 10px;
  font-size: 25px;
}

.removePrompt h5 {
  font-size: 1.1rem !important;
}
</style>
